import { useEffect, useRef } from 'react';
import { useModal } from '../contexts/modal';

export default function ApiErrorListener() {
  const { setModalProps, setIsOpenModal } = useModal();
  const lastShownRef = useRef(0);

  useEffect(() => {
    const handler = event => {
      const now = Date.now();
      if (now - lastShownRef.current < 3000) return;
      lastShownRef.current = now;

      const { message } = event.detail || {};
      setModalProps({
        title: 'Erro ao carregar dados',
        description: message || 'Ocorreu um erro inesperado. Tente novamente.',
        type: 'error',
      });
      setIsOpenModal(true);
    };

    window.addEventListener('api:error', handler);
    return () => window.removeEventListener('api:error', handler);
  }, [setModalProps, setIsOpenModal]);

  return null;
}
